export default "__VITE_ASSET__CGdlyAtd__"